import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Button, Box, Grid} from 'views/components';
import {Translate, translate, DateTimePicker} from 'views/module';

import moment from 'moment-timezone';

const EditCaregiverClockIn = (props) => {
  const {closeModel, event, onUpdateCaregiverClockIn} = props;

  const type = 'clockInConfirmation';
  const caregiverUpdates = event.caregiverUpdates;
  const caregiverUpdateIndex = caregiverUpdates.findIndex((e) => e.type === type);
  const caregiverUpdate = caregiverUpdates[caregiverUpdateIndex];

  const [clockInTime, setClockInTime] = React.useState(moment.tz(caregiverUpdate.data.suggestedClockinTimeFormatted, event.eventData.timezone));

  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    await onUpdateCaregiverClockIn(
        event.eventRn,
        type,
        moment(clockInTime).toISOString(),
        () => {
          closeModel(true);
          setIsSaving(false);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression="schedule.eventDetail.ClockInDialogTitle.Title" />
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="flex-start" sx={{mt: 0}}>
          <Grid item xs={12}>
            <DateTimePicker
              label={translate('schedule.eventDetail.EventTimelineSection.ShiftClockedIn.ClockinTime')}
              value={clockInTime}
              onChange={setClockInTime}
              textFieldProps={{fullWidth: true, InputLabelProps: {shrink: true}, sx: {mt: 0}}}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving || !clockInTime}
        >
          <Translate expression="generic.Save" />
        </Button>
      </Box>
    </Dialog>
  );
};

EditCaregiverClockIn.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onUpdateCaregiverClockIn: PropTypes.func.isRequired,
};

export default EditCaregiverClockIn;
